/**
 * @file Recalls edit-save guard helpers.
 */

/**
 * Returns whether permanent edit should show the near-date warning.
 * @param {object} item Original Recall item.
 * @param {object} data Submitted edit data.
 * @returns {boolean} True when the recall date changed.
 */
export function shouldConfirmNearDateForEdit(item = {}, data = {}) {
    return String(item.recall_date || "") !== String(data.recall_date || "");
}
